import { Type } from 'class-transformer';
import { ResidentRuleItemResultDto } from './resident-rule-item-result-dto';

export class ResidentRuleResultDto {
  headerText: string;
  @Type(() => ResidentRuleItemResultDto)
  ruleItems: Array<ResidentRuleItemResultDto>;
}
